import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { TransactionService } from './transaction.service';
/**
 * Always allows navigation and refreshes access flags when entering access-gated routes.
 * Access details are cached for 5 minutes, so only stale-cache navigations trigger an HTTP call.
 * This replaces the previous 5-minute polling and refreshes only when access-dependent areas are used.
 * Attach to the specific leaf route whose component reads an access flag; don't rely on parent guards for child/tab navigation.
 * Verify the component uses the relevant access flags or TransactionService.access() before adding this guard.
 */
@Injectable({
  providedIn: 'root'
})
export class AccessRefreshGuard {
  constructor(private transactionService: TransactionService) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
      this.transactionService.updateAccessDetailsForCurrentUser().subscribe();
      return true;
  }
}
